// store.ts
import {InjectionKey} from 'vue'
import {vuexfireMutations, firestoreAction} from 'vuexfire'
import firebase from "firebase"
import {createStore, Store, useStore as baseUseStore} from 'vuex'
import {mutations} from "@/store/mutations";
import {createEmptyTask, Review, State, Task, TaskState} from "@/store/state";
import app from "./db";
//
// export interface MyDispatch {
//     (type: Mutations, payload?: any, options?: DispatchOptions): Promise<any>;
//     <P extends BaseMutationPayloadWithType>(payloadWithType: P, options?: DispatchOptions): Promise<any>;
// }
const db = app.firestore()

// define injection key
export const key: InjectionKey<Store<State>> = Symbol()
// const fakeState: State = {
//     goals: [
//         {
//             id: "1",
//             name: "Ziel1",
//             tasks: [
//                 {
//                     owner: "",
//                     id: "gt1",
//                     deadline: null,
//                     description: "eine Beschreibung",
//                     difficulty: 2,
//                     duration: 3600,
//                     name: "durchatmen",
//                     priority: 3,
//                     state: TaskState.ToDo
//                 }
//             ]
//         }
//     ],
//     reviews: [],
//     tasks: [
//         {
//             owner: "",
//             id: "gt1",
//             deadline: new Date(),
//             description: "eine Beschreibung",
//             difficulty: 2,
//             duration: 3600,
//             name: "durchatmen",
//             priority: 3,
//             state: TaskState.ToDo
//         },
//         {
//             owner: "",
//             id: "gt2",
//             deadline: new Date(),
//             description: "eine Beschreibung2",
//             difficulty: 2,
//             duration: 3600,
//             name: "durchatmen2",
//             priority: 3,
//             state: TaskState.Doing
//         },
//         {
//             owner: "",
//             id: "gt3",
//             deadline: new Date(),
//             description: "eine Beschreibung3",
//             difficulty: 2,
//             duration: 3600,
//             name: "durchatmen3",
//             priority: 3,
//             state: TaskState.Done
//         }, {
//             owner: "",
//             id: "gt4",
//             deadline: new Date(),
//             description: "eine Beschreibung",
//             difficulty: 2,
//             duration: 3600,
//             name: "durchatmen",
//             priority: 3,
//             state: TaskState.ToDo
//         },
//         {
//             owner: "",
//             id: "gt5",
//             deadline: new Date(),
//             description: "eine Beschreibung2",
//             difficulty: 2,
//             duration: 3600,
//             name: "durchatmen2",
//             priority: 3,
//             state: TaskState.Doing
//         },
//         {
//             owner: "",
//             id: "gt6",
//             deadline: new Date(),
//             description: "eine Beschreibung3",
//             difficulty: 2,
//             duration: 3600,
//             name: "durchatmen3",
//             priority: 3,
//             state: TaskState.Done
//         }, {
//             owner: "",
//             id: "gt7",
//             deadline: new Date(),
//             description: "eine Beschreibung",
//             difficulty: 2,
//             duration: 3600,
//             name: "durchatmen",
//             priority: 3,
//             state: TaskState.ToDo
//         }
//     ],
//     user: {
//         id: "test",
//         data: ""
//     }
// }


export const store = createStore<State>({
    state: {
        user: {
            id: undefined,
            data: null
        },
        tasks: [],
        // goals: [],
        reviews: [],
        tools: [],
        categories: [],
    },
    mutations: {
        ...mutations, ...vuexfireMutations,

        setUser(state: State, user: firebase.User | null) {
            console.log("setting current user,", user);
            state.user.id = user?.uid;
            state.user.data = user
            return state;
        }
    },

    actions: {
        bindTasks: firestoreAction(async ({state, bindFirestoreRef}) => {
            // return the promise returned by `bindFirestoreRef`
            console.log("binding to collection with ",state.user.id)
            return await bindFirestoreRef('tasks', db.collection('tasks').where('owner','==',state.user.id),{ wait: true })
        }),
        unbindTasks: firestoreAction(({unbindFirestoreRef}) => {
            // return the promise returned by `bindFirestoreRef`
            return unbindFirestoreRef('tasks')
        }),
        updateTask: firestoreAction(({state}, task: Task) => {

            return db
                .collection('tasks')
                .doc(task.id)
                .update({...task})
                .then(() =>
                    console.debug("updated task: ", task.id)
                )
        }),
        deleteTask: firestoreAction(({state}, task: string) => {
            return db
                .collection('tasks')
                .doc(task)
                .delete()
                .then(() =>
                    console.debug("deleted task: ", task)
                )
        }),
        addTask: firestoreAction(({state}, task: Task) => {
            task.owner = state.user?.id
            return db
                .collection('tasks')
                .add(task)
                .then((result) =>
                    console.debug("added task: ", result)
                )
        }),

        bindReviews: firestoreAction(async ({state, bindFirestoreRef}) => {
            // return the promise returned by `bindFirestoreRef`
            console.log("binding to collection with ",state.user.id)
            return await bindFirestoreRef('reviews', db.collection('reviews').where('owner','==',state.user.id),{ wait: true })
        }),
        unbindReviews: firestoreAction(({unbindFirestoreRef}) => {
            // return the promise returned by `bindFirestoreRef`
            return unbindFirestoreRef('reviews')
        }),
        updateReview: firestoreAction(({state,dispatch}, payload) => {
            const review: Review = payload.n;
            const old: Review|null|undefined = payload.o;
            let addToTasks: string[] = review.tasks;
            let removeFromTasks: string[] = [];
            if(old){
                addToTasks = review.tasks.filter(t => !old.tasks.includes(t))
                removeFromTasks = old.tasks.filter(t => !review.tasks.includes(t))
            }
            return db
                .collection('reviews')
                .doc(review.id)
                .update({...review})
                .then(() => {
                        console.debug("updated review: ", review.id);

                        return Promise.all(state.tasks
                            .filter((t: Task) => addToTasks.includes(t.id) || removeFromTasks.includes(t.id))
                            .map((t: Task) => {
                                const upd = {...t}
                                if(removeFromTasks.includes(t.id))
                                    upd.reviews = upd.reviews.filter(el => el != review.id)
                                else if(addToTasks.includes(t.id))
                                    upd.reviews.push(review.id)
                                return dispatch('updateTask',upd)
                            })
                        );
                    }
                )
        }),
        deleteReview: firestoreAction(({state,dispatch}, payload) => {
            console.log(payload);
            const review: string = payload.id
            const tasks: string[] = payload.tasks

            return db
                .collection('reviews')
                .doc(review)
                .delete()
                .then(() => {
                        console.debug("deleted review: ", review);
                        return Promise.all(state.tasks
                            .filter((t: Task) => tasks.includes(t.id))
                            .map((t: Task) => {
                                const upd = {...t}
                                upd.reviews = upd.reviews.filter(el => el != review)
                                console.log("reviews in task",upd.reviews);
                                return dispatch('updateTask',upd)
                            })
                        );
                    }
                )
        }),
        addReview: firestoreAction(({state,dispatch}, review: Review) => {
            review.owner = state.user?.id
            return db
                .collection('reviews')
                .add(review)
                .then((result) => {
                        console.debug("added review: ", result)
                    return Promise.all(state.tasks
                        .filter((t: Task) => review.tasks.includes(t.id))
                        .map((t: Task) => {
                            const upd = {...createEmptyTask(0),...t}
                            upd.reviews.push(result.id)
                            return dispatch('updateTask',upd)
                        })
                    );
                    }
                )
        }),

        bindTools: firestoreAction(async ({state, bindFirestoreRef}) => {
            // return the promise returned by `bindFirestoreRef`
            console.log("binding to collection with ",state.user.id)
            return await bindFirestoreRef('tools', db.collection('tools').orderBy("order"),{ wait: true })
        }),
        unbindTools: firestoreAction(({unbindFirestoreRef}) => {
            // return the promise returned by `bindFirestoreRef`
            return unbindFirestoreRef('tools')
        }),
        bindCategories: firestoreAction(async ({state, bindFirestoreRef}) => {
            // return the promise returned by `bindFirestoreRef`
            console.log("binding to categories collection with ",state.user.id)
            return await bindFirestoreRef('categories', db.collection('categories').orderBy("order"),{ wait: true })
        }),
        unbindCategories: firestoreAction(({unbindFirestoreRef}) => {
            // return the promise returned by `bindFirestoreRef`
            return unbindFirestoreRef('categories')
        }),
    }
});

// store.subscribe((mutation: MutationPayload, state: State) =>{
//     localSTaskFormtorage.setItem('projectlist',JSON.stringify(state.projects));
//     if(state.currentProject!=null){
//         localStorage.setItem('project_'+state.currentProject,JSON.stringify(state.project))
//     }
// })
// define your own `useStore` composition function
export function useStore() {
    return baseUseStore(key)
}